<template>
	<div class="" style="background: #FFFFFF;">
		<!--头部-->
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>

		<div class="">
			<img class="list_img" :src="zidiyiData.zjbanner1.files" />
		</div>
		<div class="student">
			<!-- 正佳侨心班 GO -->
			<div class="pro-squad">
				<div class="info_tit">
					<div class="tit_left">
						<span>学生信息</span>
						<el-divider direction="vertical"></el-divider>
						<span>STUDENT INFORMATION</span>
					</div>
					<!-- <div class="tit_right f14" @click="goShop(6)">
						<span>查看更多</span>
						<el-divider direction="vertical"></el-divider>
						<span>MORE</span>
					</div> -->
				</div>
				<div class="row">
					<div class="banji col-xs-12 col-lg-12">
						<el-table :data="studentList" stripe style="width: 100%">
							<el-table-column prop="name" label="姓名" width="350px" align="center"> </el-table-column>
							<el-table-column prop="sex" label="性别" width="350px" align="center"> </el-table-column>
							<el-table-column prop="birthtime_text" label="日期" width="350px" align="center">
							</el-table-column>
							<el-table-column prop="hometown" label="地址" align="center"> </el-table-column>
						</el-table>
					</div>
				</div>
				<div class="row">
					<div class="fenye col-xs-12 col-lg-12">
						<div class="left pic" @click="retreat()">
							<img src="@/assets/news/right.png" />
						</div>
						<div class="">
							{{student_page}}/{{student_total}}
						</div>
						<div class="pic" @click="advance()">
							<img src="@/assets/news/right.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		add_pv,
		student_list
	} from '@/api/api.js'

	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'dqgy',
		data() {
			return {
				id: 1,
				per_page: 10,
				page: 1,
				total: 0,
				studentList: [],
				zidiyiData: {
					zjbanner1: {
						files: ''
					},

				},
				student_page: 1, //学生当前页
				student_total: 0, //学生总记录
				jiuyeList: [],
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			localStorage.setItem('current', 4)
			this.addLocatPath()
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
			this.getZidiyiData() //自定义图片
		},
		mounted() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getXueSheng(this.id)
				return
			}
			localStorage.setItem('current', 4)
		},
		methods: {
			retreat() { //学生页数后退--
				if (this.student_page == 1) {
					return
				}
				this.student_page = this.student_page - 1
				this.getXueSheng(this.id)
			},
			advance() { //学生页数前进++
				if ((this.student_total- this.student_page) <= 0) {
					return
				}
				this.student_page = this.student_page + 1
				this.getXueSheng(this.id)
			},
			getXueSheng(id) {
				let data = {
					banji_id: id,
					page: this.student_page,
					per_page: this.per_page
				}
				student_list(data).then((res) => {
					if (res.code == 1) {
						this.studentList = res.data.data
						this.studentList.map(item => {
							if (item.sex == 1) {
								item.sex = '男'
							} else {
								item.sex = '女'
							}
						})
						this.page_total = res.data.total
						this.student_total = parseInt(res.data.total/10)
					}
				}).catch(err => {});
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			toggleNext(index) {
				this.choose_type(index)
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}

				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {
					this.zidiyiData = res.data.data
				}).catch(err => {});
			},
			addLocatPath() {
				let data = {
					directions: '学生信息',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},

		},
	}
</script>

<style lang="scss" scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.m-dqgyList .col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.student {
		background: #fff;
		width: 1400px;
		margin: 0 auto;

		/* 正佳侨心班 GO */
		.pro-squad {
			margin-top: 86px;

			.info_tit {
				margin-top: 0px;
				margin-bottom: 0px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;

				.tit_left {
					span:first-child {
						font-size: 30px;
						color: #000;
						font-weight: bold;
					}

					span:last-child {
						font-size: 12px;
						color: #999;
					}
				}
			}

			.banji {
				margin-top: 32px;

				.el-table {
					/deep/.has-gutter {
						th {
							height: 80px;
							background-color: #f0f4f5;
							color: #adafb0;
						}
					}

					/deep/.el-table__row {
						height: 80px;
						color: #000000;
					}

					/deep/.el-table__row--striped {
						background-color: #f0f4f5;
						background: #f0f4f5;
					}
				}
			}

			.fenye {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 26px;
				margin-top: 32px;
				margin-bottom: 40px;

				.pic {
					width: 43px;
					height: 43px;
					display: flex;
					align-items: center;
					justify-content: center;
					border: 1px solid #E6E6E6;
					margin: 0 40px;

					img {
						width: 18px;
						height: 15px;
					}
				}

				.left {
					transform: rotate(180deg);
				}

				.pic:hover {
					background: #f0f4f5;
					cursor: pointer;
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		.m-dqgyList .list_info {
			width: 100%;
		}
	}
</style>
